package gr.tech.GRAttestation.components.modals

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import gr.tech.GRAttestation.components.inputs.StoreUserStatusDropdown
import gr.tech.GRAttestation.models.storeusers.STORE_USERS_STATUS
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreUserStatusModal(
    selectedSTATUS: STORE_USERS_STATUS,
    isInvite: Boolean,
    onClose: () -> Unit,
    onStatusChange: (STORE_USERS_STATUS) -> Unit,
) {

    var status by remember(selectedSTATUS) { mutableStateOf(selectedSTATUS) }

    fun validateForm(): Boolean {
        return true
    }

    Div(attrs = Modifier
        .classNames("card", "d-flex", "flex-column")
        .maxWidth(600.px)
        .fillMaxWidth(90.percent)
        .toAttrs {
            onClick { it.stopPropagation() }
        }
    ) {
        // Fixed Header with Close Button
        Div(attrs = Modifier.classNames("d-flex", "flex-row", "justify-content-between", "p-3", "pb-3").toAttrs()) {
            H5(Modifier.classNames("fw-bold", "m-0").toAttrs()) {
                Text("Edit Store User's Status")
            }

            Button(Modifier.classNames("btn-close").toAttrs {
                onClick { onClose() }
            })
        }

        Div(attrs = Modifier
            .classNames("px-3", "pb-3", "d-flex", "flex-column", "gap-3")
            .maxHeight(70.vh)
            .overflow(Overflow.Hidden, Overflow.Auto)
            .toAttrs()
        ) {
            // Status Dropdown
            StoreUserStatusDropdown(
                selected = status,
                isInvite = isInvite,
                onValueChange = {
                    status = it
                }
            )

            // Action Buttons
            Div(attrs = Modifier.classNames("w-100", "mt-3", "gap-2", "d-flex", "flex-row", "justify-content-between", "align-items-center").toAttrs()) {

                Button(
                    attrs = Modifier.classNames("btn", "btn-secondary")
                        .toAttrs {
                            onClick { onClose() }
                        }
                ) {
                    Text("Cancel")
                }

                Button(
                    attrs = Modifier.classNames("btn", "btn-primary")
                        .toAttrs {
                            onClick {
                                if (validateForm()) {
                                    onStatusChange(status)
                                }
                            }
                        }
                ) {
                    Text("Update Status")
                }
            }
        }
    }
}